
<template>
    <div class= "col-md-12 ml-sm-0 col-lg-12 pt-0 px-0 pl-0">
        <div class="row mx-0">
            <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5"></div>
            <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                <Select name="CapOpGroup" class="btn btn-default dropdown-toggle w-100" @change="updateDisplayBasedOnListChoice();" id="selectListCapOp">
                    <option id='Capex' selected>Capex</option>
                    <option id='Opex'>Opex</option>
                </Select>
            </div>
            <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5"></div>
        </div>
        <input id="capex" name="capex" style="visibility:hidden"/>
        <input id="opex" name="opex" style="visibility:hidden"/>
        <div id="divCapex" name="divParams" class="row w-50 m-auto">
            <div class="col-md-3">
                <input v-model="modCapex" id="modCapexXs" type="radio" name="modCapex" value="xs"/>
                <label for="modCapexXs" class="disableInput">XS : <= 500 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modCapex" id="modCapexS" type="radio" name="modCapex" value="s"/>
                <label for="modCapexS" class="disableInput">S : <= 1000 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modCapex" id="modCapexM" type="radio" name="modCapex" value="m"/>
                <label for="modCapexM" class="disableInput">M : <= 5 MWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modCapex" id="modCapexL" type="radio" name="modCapex" value="l"/>
                <label for="modCapexL" class="disableInput">L : <= 20 MWC</label>
            </div>
        </div>
        <div id="divOpex" name="divParams" class="row w-50 m-auto">
            <div class="col-md-3">
                <input v-model="modOpex" id="modOpexXs" type="radio" name="modOpex" value="xs"/>
                <label for="modOpexXs" class="disableInput">XS : <= 500 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modOpex" id="modOpexS" type="radio" name="modOpex" value="s"/>
                <label for="modOpexS" class="disableInput">S : <= 1000 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modOpex" id="modOpexM" type="radio" name="modOpex" value="m"/>
                <label for="modOpexM" class="disableInput">M : <= 5 MWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="modOpex" id="modOpexL" type="radio" name="modOpex" value="l"/>
                <label for="modOpexL" class="disableInput">L : <= 20 MWC</label>
            </div>
        </div>
        <div id="chartCapex" name="divParams" class= "row mx-0">
            <chartCapex :capex="capexopex[0].Capex" :mode="modCapex"></chartCapex>
        </div>
        <div id="chartOpex" name="divParams" class= "row mx-0">
            <chartOpex :opex="capexopex[1].Opex" :modeOpex="modOpex"></chartOpex>
        </div>
    </div>
</template>

<script >
    import chartCapex from './charts/chartCapex.vue';
    import chartOpex from './charts/chartOpex.vue';

    export default {
        components: {
            chartCapex, chartOpex
        },
        props : ['capexopex'],     
        
        data : function(){
            return {
                Capex :[],
                Opex:[],
                Implement:0,
                modCapex: 's',
                modOpex: 's',
            };
        },
        mounted: function(){
            
            this.Capex = JSON.parse(JSON.stringify(this.capexopex[0].Capex));
            this.Opex = JSON.parse(JSON.stringify(this.capexopex[1].Opex));
            var keyCapex = Object.keys(this.Capex);
            var keyOpex = Object.keys(this.Opex);
            
            var temp3 = [];
            var temp=[];

            keyCapex.forEach(element => {
                temp.push({'name':element,"value" : JSON.parse(JSON.stringify(this.Capex[element]))});
            });
            
            temp.forEach(element=>{
                var keyPuissance =Object.keys(element.value);
                
                var temp2 = [];
                keyPuissance.forEach(element2 =>{
                    
                    temp2.push({'name':element2, "value":element.value[element2] });
                });
                temp3[element.name]=temp2;
            });

            this.Capex = temp3;

            var temp3 = [];

            var temp=[];

            keyOpex.forEach(element => {
                temp.push({'name':element,"value" : JSON.parse(JSON.stringify(this.Opex[element]))});
            });
            
            temp.forEach(element=>{
                var keyPuissance =Object.keys(element.value);
                
                var temp2 = [];
                keyPuissance.forEach(element2 =>{
                    
                    temp2.push({'name':element2, "value":element.value[element2] });
                });
                temp3[element.name]=temp2;
            });

            this.Opex = temp3;
            document.getElementById("divOpex").style.display="none";
            document.getElementById("chartOpex").style.display="none";

        },
        methods :{
            actualise(index,type,table){
                if(table=="capex"){
                    document.getElementById(type + (index+1)).innerText= this.Capex[type][index].name;
                    document.getElementById(type).value= JSON.stringify(this.Capex[type]);
                }else{
                    document.getElementById(type + (index+1)).value= this.Opex[type][index].name;
                    document.getElementById(type).value= JSON.stringify(this.Opex[type]);
                }
            },
            actualiseValue(type, table){
                if(table=="capex"){
                   
                    document.getElementById(type).value= JSON.stringify(this.Capex[type]);
                }else{
                    document.getElementById(type).value= JSON.stringify(this.Opex[type]);
                    
                }
            },
            addPower(type,table){
                if(table=="capex"){
                    
                    var nbPuissance = this.Capex[type].length;
                    var newTab = [];
                    var i = 0;
                    var j = 0;
                    while(j<nbPuissance+1){
                        if(j==nbPuissance-1){
                            newTab.push(this.Capex[type][i-1]);
                            j++;
                        }else{
                            newTab.push(this.Capex[type][i]);
                            j++;
                            i++;
                        }
                    }
                    this.Capex[type]=newTab;
                    this.Implement++;
                }else{
                    var nbPuissance = this.Opex[type].length;
                    var newTab = [];
                    var i = 0;
                    var j = 0;
                    while(j<nbPuissance+1){
                        if(j==nbPuissance-1){
                            newTab.push(this.Opex[type][i-1]);
                            j++;
                        }else{
                            newTab.push(this.Opex[type][i]);
                            j++;
                            i++;
                        }
                    }
                    this.Opex[type]=newTab;
                    this.Implement++;


                }
            },
            updateDisplayBasedOnListChoice() {
                var item = document.getElementById("selectListCapOp");
                document.getElementsByName("divParams").forEach(function(element) {
                    if(element.id == "div"+item[item.selectedIndex].id || element.id == "chart"+item[item.selectedIndex].id){
                        if(element.id.startsWith('chart')){
                            element.style.display="block";
                        } else {
                            element.style.display="flex";
                        }
                    } else {
                        element.style.display="none";                    
                    }
                });
            }
        }
    }

</script>
